export default __webpack_public_path__ + "static/media/facebook_icon.155fcaaf.png";